import { Component, OnInit } from '@angular/core';
import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './immigration-types.component.html',
    styleUrls: ['./immigration-types.component.scss'],
    standalone: false
})
export class ImmigrationTypesModalComponent extends BaseModalDirective implements OnInit {
    globalLang: string;

    ngOnInit(): void {
        this.globalLang = sessionStorage.getItem('globalTranslatedLan');
    }
}
